import { NgModule, ErrorHandler, LOCALE_ID } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { ToastaModule } from 'ngx-toasta';

import { AppRoutingModule } from './app-routing.module';
import { AppErrorHandler } from './app-error.handler';

import { SharedModule } from './shared/shared.module';
import { AdminModule } from './admin/admin.module';
import { SettingsModule } from './settings/settings.module';
import { ThemePickerModule } from './shared/theme-picker.component';

import { ReportModule } from './reports/components/report.module';
import { ApiModule } from './reports/api.module';

import { AppTranslationService, TranslateLanguageLoader } from './services/app-translation.service';
import { ConfigurationService } from './services/configuration.service';
import { AlertService } from './services/alert.service';
import { LocalStoreManager } from './services/local-store-manager.service';
import { OidcHelperService, OidcTempStorage } from './services/oidc-helper.service';
import { AccountService } from './services/account.service';
import { AccountEndpoint } from './services/account-endpoint.service';
import { ReportHelperService } from './services/report-helper.service';

import { AppComponent } from "./app.component";
import { LoginComponent } from "./components/login/login.component";
import { LoginControlComponent } from "./components/login/login-control.component";
import { LoginDialogComponent } from "./components/login/login-dialog.component";
import { HomeComponent } from "./components/home/home.component";
import { AboutComponent } from "./components/about/about.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";


// Translation for the pager
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorHandler } from "./i18n/matpaginator.handler";
import { RefreshTokenHttpInterceptor } from "./RefreshTokenHttpInterceptor";
import { Configuration } from './reports';
import { AuthService } from './services/auth.service';

@NgModule({ declarations: [
        AppComponent,
        LoginComponent, LoginControlComponent, LoginDialogComponent,
        HomeComponent,
        AboutComponent,
        NotFoundComponent,
    ],
    bootstrap: [AppComponent], imports: [SharedModule,
        ThemePickerModule,
        AdminModule,
        ReportModule,
        ApiModule,
        SettingsModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateLanguageLoader
            }
        }),
        OAuthModule.forRoot(),
        ToastaModule.forRoot(),
        ], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenHttpInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        { provide: OAuthStorage, useClass: OidcTempStorage },
        {
            provide: Configuration,
            useFactory: (authService: AuthService, configurationService: ConfigurationService) => new Configuration({
                basePath: configurationService.baseUrl,
                accessToken: authService.getAccessToken.bind(authService)
            }),
            deps: [AuthService, ConfigurationService],
            multi: false
        },
        AlertService,
        ConfigurationService,
        AppTranslationService,
        AccountService,
        AccountEndpoint,
        LocalStoreManager,
        OidcHelperService,
        ReportHelperService,
        { provide: MatPaginatorIntl, useClass: MatPaginatorHandler },
        {
            provide: LOCALE_ID,
            deps: [ConfigurationService],
            useFactory: (configurationService) => configurationService.language
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule {
}
